import React from 'react';
import {Placeholder} from 'semantic-ui-react';

export const SectionPlaceholder: React.FC = () => {
  return (
    <Placeholder fluid>
      <Placeholder.Header image>
        <Placeholder.Line length={'medium'} />
        <Placeholder.Line length={'medium'} />
      </Placeholder.Header>
      <Placeholder.Paragraph>
        <Placeholder.Line length="medium" />
        <Placeholder.Line length="short" />
      </Placeholder.Paragraph>
    </Placeholder>
  );
};
